<div
  [class.required]='
    control && (control.dirty || control.touched) && control.errors
  '
  class='AppTextField d-flex flex-row AppTextField-{{ fieldBackgroundClass }}'>
  <ng-container *ngIf="type !== 'date'">
    <input
      [attr.data-testid]="getTestId()"
      [attr.data-credential]="allowViewPassword || type === 'password' ? 'password' : type === 'email' ? 'username' : null"
      [attr.autocomplete]="autocomplete || null"
      [attr.id]="inputId || null"
      [attr.name]="name || null"
      (keyup)='onValueChange($event)'
      (ngModelChange)='valueChanges($event)'
      [(ngModel)]='value'
      [ngModelOptions]="{ standalone: true }"
      [appCopyText]='canCopy'
      [disabled]='disabled'
      [placeholder]='getPlaceholder()'
      [required]="isInputRequired()"
      [type]='type' />
    <label>{{ getPlaceholder() }}</label>
    <span (click)='showPassword()' *ngIf='allowViewPassword' class='AppTextField-password-toggle-icon'><fa-icon [attr.data-testid]="getTestId('input-icon')"
      [icon]='iconPasswordView'></fa-icon></span>
  </ng-container>
  <ng-container *ngIf="type === 'date'">
    <input
      [attr.data-testid]="getTestId()"
      (keyup)='onValueChange($event)'
      (ngModelChange)='valueChanges($event)'
      (change)="valueChanges($event)"
      [(ngModel)]='value'
      [ngModelOptions]="{ standalone: true }"
      [disabled]='disabled'
      [min]='datePickerStartDate'
      [owlDateTimeTrigger]='datetimePicker'
      [owlDateTime]='datetimePicker'
      [placeholder]='getPlaceholder()' />
    <owl-date-time
      #datetimePicker
      [hour12Timer]='true'
      [pickerType]='datePickerType' [stepMinute]='minutesSteps'></owl-date-time>
    <span
      [owlDateTimeTrigger]='datetimePicker'
      class='AppTextField__icon clickable'
    ><fa-icon [attr.data-testid]="getTestId('input-icon')" [icon]='iconCalendar'></fa-icon
    ></span>
  </ng-container>
  <div
    *ngIf='iconProps'
    [class.clickable]='iconProps.updateOnClick'
    class='AppTextField__icon'>
    <fa-icon [attr.data-testid]="getTestId('input-icon')" (click)='onIconClick()' [icon]='iconProps.icon'></fa-icon>
  </div>
</div>
